<template>
  <div class="custom-carousel">
    <swiper
      :options="swiperOption"
      :dir="$vs.rtl ? 'rtl' : 'ltr'"
      :key="$vs.rtl"
    >
      <swiper-slide
        v-for="(report, index) in reports"
        :key="index"
        class="cursor-pointer custom-card-carousel flex"
        :class="{ 'highlight-item-selected': isItemSelected(report) }"
      >
        <vs-card
          class="highlight-card"
          :class="{ 'highlight-invite': isDisclosureInvite(report) }"
        >
          <div
            slot="header"
            class="highlight-header-div mosaic"
            @click="openReportDetail(report)"
          >
            <div class="vx-row">
              <div class="vx-col" >
                <div class="badge live" v-if="report.inLive">
                    <div class="badge-wrap">
                        <span class="badge-icon">
                          <svg height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 2.333c2.577 0 4.667 2.09 4.667 4.667S9.577 11.667 7 11.667 2.333 9.577 2.333 7 4.423 2.333 7 2.333zm0 1.05c-1.997 0-3.617 1.62-3.617 3.617 0 1.997 1.62 3.617 3.617 3.617 1.997 0 3.617-1.62 3.617-3.617 0-1.997-1.62-3.617-3.617-3.617z"></path></svg><span class="badge-icon-inner"><svg aria-hidden="true" focusable="false" viewbox="0 0 14 14"><path d="M7 9.567c1.418 0 2.567-1.15 2.567-2.567 0-1.418-1.15-2.567-2.567-2.567-1.418 0-2.567 1.15-2.567 2.567 0 1.418 1.15 2.567 2.567 2.567z"></path>
                          </svg>
                        </span>
                      </span>
                      <span class="">{{$t('BADGES').InLive}}</span>
                    </div>
                  </div>
                  <div class="badge" v-if="isImportant(report) && !report.inLive">
                    <div class="badge-wrap"> 
                      <span class="badge-text">{{$t('BADGES').Important}}</span>
                    </div>
                  </div>
                  <div class="badge disclosure-announcement-badge" v-if="isDisclosureAnnouncement(report)">
                    <div class="badge-wrap"> 
                      <span class="badge-text">{{$t('BADGES').Announcement}}</span>
                    </div>
                  </div>
                  <div class="badge disclosure-invite-badge" v-if="isDisclosureInvite(report)">
                    <div class="badge-wrap"> 
                      <span class="badge-text">{{$t('BADGES').Invite}}</span>
                    </div>
                  </div>

                <div class="img-high" :style="getThumbPathStyle(report)">
                  
                </div>
                <!-- <img
                  class="img-high"
                  :src="report.thumb.image_path"
                  v-if="report.thumb"
                /> -->
              </div>
              <div class="vx-col flex-1">
                <div class="vx-row title-highlights flex">
                  <h5 class="vx-col pl-0 w-80">{{ hat(report) }} — {{report.data_object | moment("from")}}</h5>
                </div>
                <div class="vx-row title-highlights mr-4" >
                  {{ getTitle(report) }} — {{ $t('VIEW_MODES').By}} {{report.author.name}}
                  
                </div>
                
                
              </div>
            </div>
            
          </div>
          <div class="" @click="openReportDetail(report)">
            <!-- <span class="icon-svg-back">
              <feather-icon class="back-icon-highlightcard" :icon="getSubjectIcon(report.subjects)" :svgClasses="['h-16 w-16 icon-safra']"></feather-icon>
            </span> -->
            <!-- <div class="highlight-card-content-info">
              <dropdown-user-info
                :isCardView="true"
                :avatarUrl="report.author.image_path"
                :username="report.author.name"
                :resume="report.author.resume"
                :isDesktop="isDesktop"
              ></dropdown-user-info>

              <div
                class="filter-chip-card px-1 mrF-1"
                v-if="report.characteristic"
              >
                {{ getTranslateData(report.characteristic) }}
              </div>
              <div class="filter-chip-card px-1 mr-1" v-if="report.periodicity">
                {{ getTranslateData(report.periodicity) }}
              </div>
              <div
                class="badge exclusive-chip"
                v-if="isDisclosureInvite(report)"
              >
                <div class="badge-wrap">
                  <span class="badge-text">CONVITE</span>
                </div>
              </div>
            </div> -->
          </div>
          <div class="flex float-right actions-bar">
            <div class="flex icons-details items-center" v-if="report.displayDetail">
              <template v-if="report.displayDetail">
                <feather-icon
                  v-if="canAddPlaylist(report)"
                  icon="PlaylistIcon"
                  class="playlist-icon"
                  @click.stop="addPlaylist(report)"
                />
                <feather-icon
                  v-if="hasMultimedia(report)"
                  :icon="getIconCard(report)"
                  class=""
                  @click.stop="playMultimedia(report, false)"
                />
                <feather-icon
                  v-if="canSpeechText(report)"
                  icon="Volume1Icon"
                  class=""
                  @click.stop="playMultimedia(report, true)"
                />
                <feather-icon
                  icon="PaperclipIcon"
                  class=""
                  v-if="report.document"
                  @click.stop="onDownloadDocument(report)"
                />
              </template>
            </div>
            <div class="flex icons-details items-center" v-if="!report.displayDetail">
              <vx-tooltip :text="$t('HIGHLIGHTS').Exclusive_Content" delay=".1s"><span  class="iconsafra"><feather-icon @click.stop="$emit('open-exclusive-content')" icon="LockIcon" class="mr-0" :svgClasses="['icon-Volume']"/></span></vx-tooltip>
            </div>
          </div>
        </vs-card>
      
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination swiper-pagination-custom" slot="pagination"></div>
  </div>
</template>

<script>
  import DropdownUserInfo from '../widgets/dropdown-user-info/DropdownUserInfo.vue';
  import "swiper/dist/css/swiper.min.css";
  import {swiper, swiperSlide} from "vue-awesome-swiper";
  import { CONTENT } from '../../../enums/enum-content';
  import AppConstants from '../../../appConstants';
  import translateFieldHelper from '../../../helpers/translate-field-helper';
  import formatFieldHelper from '../../../helpers/format-field-helper';
import generalHelper from '../../../helpers/general-helper';

export default {
  props: {
    reports: {
      type: Array,
      required: true
    },
    currentCommodity: {
      require: true
    },
    currentSelected: { type: Object },
    isAuthenticated: {
      type: Boolean
    }
  },
  data() {
    return {
      // swiperOption: {
      //   slidesPerView: this.isCardView ? 3 : 1,
      //   spaceBetween: 5,
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   },
      // }
      // swiperOption: {
      //   slidesPerView: 3,
      //   spaceBetween: 5,
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   },
      //   breakpoints: {
      //     1024: {
      //       slidesPerView: 3,
      //       spaceBetween: 15
      //     },
      //     768: {
      //       slidesPerView: 1,
      //       spaceBetween: 15
      //     },
      //     640: {
      //       slidesPerView: 1,
      //       spaceBetween: 15
      //     }
      //   }
      // }
    };
  },
  computed: {
      isCardView() {
        return this.$store.state.reportViewStyle === AppConstants.REPORT_VIEW_STYLE.CARDVIEW;
      },
      isMosaicView() {
        return this.$store.state.reportViewStyle === AppConstants.REPORT_VIEW_STYLE.MOSAIC;
      },
      swiperOption() {
        return {
          slidesPerView: this.getSlidesPerView,
          spaceBetween: 5,
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
        }
      },
      getSlidesPerView() {
        if (this.isCardView) {
          return 2;
        }
        if (this.isMosaicView) {
          return 4;
        }
        return 1;
      },
      isDesktop() {
        return this.$store.state.isDesktop;
      },
      windowWidth() {
        return this.$store.state.windowWidth;
      },
      AppActiveUser() {
        return this.$store.state.AppActiveUser;
      },
    },
    methods: {
      canSpeechText(data) {
        return generalHelper.canSpeechText(data, this.isDesktop);
      },
      onDownloadDocument(data) {
        this.$emit("onDownloadFile", data);
      },
      playMultimedia(data, isTextSpeech = false) {
        this.$emit("playMultimedia", {
          data: data,
          isTextSpeech: isTextSpeech
        });
      },
      getIconCard(data) {
        if (data.youtubeId) {
          return "VideoIcon";
        } else if (data.audio || data.spotify || data.soundcloud) {
          return "MicIcon";
        } else if (data.document) {
          return "PaperclipIcon";
        } else {
          return null;
        }
      },
      hasMultimedia(data) {
        return (!!data.youtubeId || !!data.audio || !!data.spotify || !!data.soundcloud)
      },
      addPlaylist(data) {
        this.$store.dispatch("insertItemPlaylist", data);
      },
      canAddPlaylist(data) {
        return (!!data.youtubeId || !!data.audio || !!data.spotify || !!data.soundcloud) && this.isAuthenticated;
      },
      getTitle(item) {
        if (!item) return '';
        if (item.newsContent[0].code == CONTENT.STATISTIC ||
          item.newsContent[0].code == CONTENT.EXPORTS ||
          item.newsContent[0].code == CONTENT.INFORMATIVE) {
            return translateFieldHelper.getTranslateField('name', item.reportType);
          }
        return formatFieldHelper.limitFieldLength(item.content.title.data, AppConstants.HIGHLIGHTS_TITLE_LIMIT_LENGTH);
      },
      isImportant(item) {
        if (!item) {
          return false;
        }
        return item.importance > 0;
      },
      isDisclosureAnnouncement(item) {
        return (item.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.ANNOUNCEMENT);
      },
      isDisclosureInvite(item) {
        return (item.disclosureType == AppConstants.DISCLOSURE_TYPE_ENUM.INVITE);
      },
      headerStyle(item) {
        try {
          let commodityFile = '';
          let originCode = formatFieldHelper.getOriginCode(this.AppActiveUser);
          if (this.currentCommodity.id && this.currentCommodity.id > 0) {
            commodityFile = require(`../../../assets/images/commodity/${originCode}/${this.currentCommodity.id}.png`);
          } else {
            commodityFile = require(`../../../assets/images/commodity/${originCode}/${item.subjects[0].code}.png`);
          }
          return `background-image: url("${commodityFile}");`;
        } catch (e) {
          console.log(e);
          return "";
        }
      },
      getThumbPathStyle(item) {
        if (item.thumb) {
          return `background-image:url('${item.thumb.image_path}')`;
        }
        return this.headerStyle(item);
      },
      hat(item) {
        if (item) {
          if (item.hat[0]) {
            return item.hat[0].name.toUpperCase();
          }
        }
        return "";
      },
      isItemSelected(item) {
        if (!this.currentSelected) return false;
        return item._id == this.currentSelected._id;
      },
      isItemNews(data) {
        if (data.newsContent[0]) {
          if (data.newsContent[0].code == CONTENT.NEWS) {
            return true;
          }
        }
        return false;
      },
      getTranslateData(data) {
        return data[`name${this.$i18n.locale}`];
      },
      getSubjectName(subjects) {
        return translateFieldHelper.getSubjectName(subjects, this.currentCommodity);
      },
      getSubjectIcon(subjects) {
        if (this.currentCommodity.id) {
          const sub = subjects.find(item => item.code == this.currentCommodity.id);
          if (sub) {
            return sub.icon;
          }
        }
        return subjects[0].icon;
      },
      isReportDateToday() {
        if (this.report) {
          return this.report.data_object.getUTCDate() == new Date().getUTCDate();
        }
        return false;
      },
      openReportDetail(report) {
        this.$emit('openReportDetail', report);
      },
      getManchete(report) {
        if (report.hat[0]) {
          return report.hat[0].name;
        }
        return '';
      }
    },
  components: {
    DropdownUserInfo,
    swiper,
    swiperSlide
  }
};
</script>

<style>

</style>
